<template>
    <div class="index">
        <box-helper
            headline="Overblik"
            identifier="index"
        />
        <div class="container section">
            <title-block headline="<b>Overblik</b>" class="mb-xl" position="center">
                <p slot="text">
                    Hvad skal der fokus på i dag?
                </p>
            </title-block>
            <div class="content">
                <div class="economy-overview-boxes">
                    <div class="row nomargin">
                        <div class="col-lg-7">
                            <div class="economy-overview-box">
                                <div class="period">
                                    Realiseret for perioden
                                </div>
                                <div class="inside">
                                    <div class="row nomargin">
                                        <div class="col-lg-4">
                                            <div class="small-title">
                                                EBITDA
                                            </div>
                                            <div class="large-title">
                                                <span v-if="keyfigures">{{ keyfigures.ebitda | currency }}</span>
                                                <span v-else><i class="fas fa-spinner fa-spin" /></span>
                                            </div>
                                        </div>
                                        <div class="col-lg-4">
                                            <div class="small-title">
                                                Solgte timer
                                            </div>
                                            <div class="large-title">
                                                <span v-if="keyfigures">{{ keyfigures.hours | number }}</span>
                                                <span v-else><i class="fas fa-spinner fa-spin" /></span>
                                            </div>
                                        </div>
                                        <div class="col-lg-4">
                                            <div class="small-title">
                                                DB pr. time
                                            </div>
                                            <div
                                                class="large-title"
                                                :class="{'color-bad': keyfigures.coverage_per_hour < $store.state.config.companyMeta.settings.coverage_percent.medium.value, 'color-avg': $options.filters.rounded(keyfigures.coverage_per_hour) >= $store.state.config.companyMeta.settings.coverage_percent.medium.value && $options.filters.rounded(keyfigures.coverage_per_hour) < $store.state.config.companyMeta.settings.coverage_percent.high.value, 'color-good': $options.filters.rounded(keyfigures.coverage_per_hour) >= $store.state.config.companyMeta.settings.coverage_percent.high.value}"
                                                v-if="keyfigures"
                                            >
                                                {{ keyfigures.coverage_per_hour | currency }}
                                                
                                            </div>
                                            <div class="large-title" v-else>
                                                <i class="fas fa-spinner fa-spin" />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-lg-5">
                            <expected-ebitda />
                        </div>
                    </div>
                </div>
                
                <value-chain />

                <div class="number-overview">
                    <div class="row">
                        <div class="col-lg-2">
                            <number-card
                                heading="Tilbud"
                                description="der afventer afgørelse"
                                :number="calculations.offer"
                                icon="file-alt"
                                state="avg"
                                linkParent="ProjectsOperations"
                                linkChild="offerProjects"
                                tooltipIdentifier="index.offerProjects"
                            />
                        </div>
                        <div class="col-lg-2">
                            <number-card
                                heading="Opgaver"
                                description="der endnu ikke er påbegyndt"
                                :number="calculations.open"
                                icon="inbox-in"
                                state="avg"
                                linkParent="ProjectsOperations"
                                linkChild="openProjects"
                                tooltipIdentifier="index.openProjects"
                            />
                        </div>
                        <div class="col-lg-2">
                            <number-card
                                heading="Igangværende opgaver"
                                description="der arbejdes på lige nu"
                                :number="calculations.ongoing"
                                icon="clock"
                                state="bad"
                                linkParent="ProjectsOperations"
                                linkChild="ongoingProjects"
                                tooltipIdentifier="index.ongoingProjects"
                            />
                            <br>
                            <number-card
                                heading="Igangværende opgaver"
                                :description="'uden registreringer i ' + $store.state.config.companyMeta.settings.snoozed_days + ' dage '"
                                :number="calculations.snoozed"
                                icon="snooze"
                                state="bad"
                                linkParent="ProjectsOperations"
                                linkChild="snoozedProjects"
                                tooltipIdentifier="index.snoozedProjects"
                            />
                            <br>
                            <number-card
                                heading="Reklamationer"
                                description="der ikke er afsluttet"
                                :number="calculations.claims"
                                icon="comment-exclamation"
                                state="good"
                                linkParent="ProjectsOperations"
                                linkChild="openClaims"
                                tooltipIdentifier="index.openClaims"
                            />
                        </div>
                        <div class="col-lg-2">
                            <number-card
                                heading="Afsluttede opgaver"
                                description="der ikke er fakturerede"
                                :number="calculations.unbilled"
                                icon="envelope-open-dollar"
                                state="avg"
                                linkParent="ProjectsOperations"
                                linkChild="noInvoiceProjects"
                                tooltipIdentifier="index.unbilledProjects"
                            />
                        </div>
                        <div class="col-lg-2">
                            <number-card
                                heading="Fakturaer"
                                description="der endnu ikke er betalt"
                                :number="calculations.payment_pending"
                                icon="envelope-open-dollar"
                                state="avg"
                                linkParent="EconomyOperations"
                                linkChild="unpaidInvoices"
                                tooltipIdentifier="index.unpaidInvoices"
                            />
                        </div>
                        <div class="col-lg-2">
                            <number-card
                                heading="Fakturaer"
                                :description="'hvor betaling er overskredet med ' + $store.state.config.companyMeta.settings.overdue_days + ' dage'"
                                :number="calculations.payment_exceeded"
                                icon="calendar-exclamation"
                                state="bad"
                                :totalValue="calculations.payment_exceeded_total"
                                linkParent="EconomyOperations"
                                linkChild="exceededPayments"
                                tooltipIdentifier="index.overdueInvoices"
                            />
                        </div>
                    </div>
                </div>

                <!--<div class="number-overview">
                    <div class="row nomargin">
                        <div class="col-lg-4 col-md-6 col-sm-12">
                            <number-card
                                heading="Opgaver"
                                description="der endnu ikke er påbegyndt"
                                :number="calculations.open"
                                icon="inbox-in"
                                state="avg"
                                linkParent="ProjectsOperations"
                                linkChild="openProjects"
                                tooltipIdentifier="index.openProjects"
                            />
                        </div>
                        <div class="col-lg-4 col-md-6 col-sm-12">
                            <number-card
                                heading="Igangværende opgaver"
                                description="der arbejdes på lige nu"
                                :number="calculations.ongoing"
                                icon="clock"
                                state="bad"
                                linkParent="ProjectsOperations"
                                linkChild="ongoingProjects"
                                tooltipIdentifier="index.ongoingProjects"
                            />
                        </div>
                        <div class="col-lg-4 col-md-6 col-sm-12">
                            <number-card
                                heading="Igangværende opgaver"
                                :description="'uden registreringer i ' + $store.state.config.companyMeta.settings.snoozed_days + ' dage '"
                                :number="calculations.snoozed"
                                icon="snooze"
                                state="bad"
                                linkParent="ProjectsOperations"
                                linkChild="snoozedProjects"
                                tooltipIdentifier="index.snoozedProjects"
                            />
                        </div>
                        <div class="col-lg-4 col-md-6 col-sm-12">
                            <number-card
                                heading="Reklamationer"
                                description="der ikke er afsluttet"
                                :number="calculations.claims"
                                icon="comment-exclamation"
                                state="good"
                                linkParent="ProjectsOperations"
                                linkChild="openClaims"
                                tooltipIdentifier="index.openClaims"
                            />
                        </div>
                        <div class="col-lg-4 col-md-6 col-sm-12">
                            <number-card
                                heading="Afsluttede opgaver"
                                description="der ikke er fakturerede"
                                :number="calculations.unbilled"
                                icon="envelope-open-dollar"
                                state="avg"
                                linkParent="ProjectsOperations"
                                linkChild="noInvoiceProjects"
                                tooltipIdentifier="index.unbilledProjects"
                            />
                        </div>
                        <div class="col-lg-4 col-md-6 col-sm-12">
                            <number-card
                                heading="Fakturaer"
                                :description="'hvor betaling er overskredet med ' + $store.state.config.companyMeta.settings.overdue_days + ' dage'"
                                :number="calculations.payment_exceeded"
                                icon="calendar-exclamation"
                                state="bad"
                                :totalValue="calculations.payment_exceeded_total"
                                linkParent="EconomyOperations"
                                linkChild="exceededPayments"
                                tooltipIdentifier="index.overdueInvoices"
                            />
                        </div>
                    </div>
                </div>-->

            </div>
        </div>
    </div>
</template>

<style lang="scss">
@import "../../styles/vars.scss";
    
    .index {

        .fa-spinner {
            color: #fff !important;
        }

        span.cta {
            color: #fff !important;
            transition: 0.3s ease all;
            cursor: pointer;
            font-size: $fontsize--main * 1.2;

            &:hover {
                color: #03a9f4 !important;
            }
        }

        .economy-overview-boxes {
            margin-bottom: $margin--large;

            .economy-overview-box {
                background: $color--dark;
                color: #fff;
                border-radius: $borderradius--main;
                box-shadow: $boxshadow--creative;
                overflow: hidden;
                text-align: center;
                height: 100%;
                display: flex;
                flex-direction: column;

                .inside {
                    padding: $padding--main;
                    flex: 1;
                    display: flex;
                    flex-direction: column;
                    justify-content: center;
                }

                .period {
                    background: rgba(255, 255, 255, 0.05);
                    padding: 10px;
                    text-align: center;
                    font-weight: bold;
                    font-family: $fontfamily--main;
                    color: #fff;
                }

                .small-title {
                    margin-bottom: 5px;
                }

                .large-title {
                    font-size: $fontsize--main * 1.6;
                    font-weight: $fontweight--bold;
                    font-family: $fontfamily--main;
                }
            }
        }

        .economy-overview {
            background: $color--dark;
            margin-bottom: $margin--xl;
            margin-bottom: $margin--large;
            padding: $padding--main;
            border-radius: $borderradius--main;
            text-align: center;
            box-shadow: $boxshadow--creative;
            color: #fff;

            [class^="col-"] {

                &:nth-of-type(2) {
                    border-left: 1px solid lighten($color--dark, 10%);
                    border-right: 1px solid lighten($color--dark, 10%);
                }

                .text {
                    font-size: $fontsize--main;
                    font-weight: $fontweight--main;
                    margin-bottom: $margin--small / 2;
                }

                .number {
                    font-size: $fontsize--xxl;
                    font-weight: $fontweight--bold;
                    font-family: $fontfamily--main;
                }
            }
        }

        .number-overview {
            margin-bottom: $margin--xl;
            margin-bottom: $margin--main;
        }

        .tables-overview {
            margin-bottom: $margin--xl;
            margin-bottom: $margin--main;
        }
    }

</style>

<script>
import * as calculationService from '@/services/calculationService'

export default {
    data () {
        return {
            showHelper: false,
            keyfigures: null,
            calculations: {
                offer: null,
                claims: null,
                close_to_budget: null,
                ongoing: null,
                open: null,
                payment_pending: null,
                payment_exceeded: null,
                payment_exceeded_total: null,
                snoozed: null,
                unbilled: null
            }
        }
    },
    methods: {
        getCalculations () {
            this.calculations = {
                offer: null,
                claims: null,
                close_to_budget: null,
                ongoing: null,
                open: null,
                payment_pending: null,
                payment_exceeded: null,
                payment_exceeded_total: null,
                snoozed: null,
                unbilled: null
            }
            let params = {
                date_from: this.$store.getters.getStartDate,
                date_to: this.$store.getters.getEndDate
            }
            if (this.$store.getters.getCurrentDepartment.uuid !== 0) {
                params.department = this.$store.getters.getCurrentDepartment.uuid
            }
            calculationService.find('index/counts', params, (response) => {
                this.calculations = response.data
            }, (err) => {
                console.log(err)
            })
        },
        getEconomyData () {
            this.keyfigures = null
            let params = {
                date_from: this.$store.getters.getStartDate,
                date_to: this.$store.getters.getEndDate
            }
            if (this.$store.getters.getCurrentDepartment.uuid !== 0) {
                params.department = this.$store.getters.getCurrentDepartment.uuid
            }
            calculationService.find('index-economy', params, (response) => {
                this.keyfigures = response.data
                console.log(response.data)
            }, (err) => {
                console.log(err)
            })
        }
    },
    created () {
        this.getCalculations()
        this.getEconomyData()
    },
    computed: {
        globalParams () {
            let startDate = this.$store.getters.getStartDate
            let endDate = this.$store.getters.getEndDate
            let department = this.$store.getters.getCurrentDepartment.uuid
            return startDate + endDate + department
        }
    },
    watch: {
        globalParams: function () {
            this.getCalculations()
            this.getEconomyData()
        }
    },
    components: {
        'value-chain': require('./components/valueChain.vue'),
        'expected-ebitda': require('./components/expectedEbitda.vue')
    }
}
</script>



// WEBPACK FOOTER //
// index.vue?f0687de6